module.exports = __webpack_public_path__ + "static/media/select_dropdown.db9b4455.svg";